export default {"src":"https://assets.madeeasy.in/non-prod/_next/static/media/pdf-list.21e88cf5.svg","height":114,"width":114,"blurWidth":0,"blurHeight":0};